/**
 * This file contains utility functions for logging messages for the E2E testing.
 */

/**
 * LOG FILE DOWNLOAD MESSAGES
 */

// Ensure that the file type is consistent with the file that was downloaded.
const csvFileDownloaded = 'CSV file downloaded successfully';
const xlsFileDownloaded = 'XLS file downloaded successfully';

/**
 * Logs a message indicating the type of file downloaded during E2E testing.
 * @param {string} fileType - The type of file that was downloaded.
 */
async function logFileDownloadMessage(fileType, filters = null) {
    // Clear the console, so previous log don't interfere with the current message
    console.clear();
    // Log the message
    if (fileType === 'CSV') {
        console.log(csvFileDownloaded);
    } else {
        console.log(xlsFileDownloaded);
    }
    // Log filters if they exist
    if (filters) {
        console.log('Filters:', filters);
    }
}

export { csvFileDownloaded, logFileDownloadMessage, xlsFileDownloaded };
